function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_8",
  "data-name": "Path 8",
  d: "M240,171a3,3,0,1,0-3-3A2.987,2.987,0,0,0,240,171Zm-8,0a3,3,0,1,0-3-3A2.987,2.987,0,0,0,232,171Zm0,2c-2.33,0-7,1.17-7,3.5V178a1,1,0,0,0,1,1h12a1,1,0,0,0,1-1v-1.5C239,174.17,234.33,173,232,173Zm8,0c-.29,0-.62.02-.97.05.02.01.03.03.04.04A4.16,4.16,0,0,1,241,176.5V178a3,3,0,0,1-.18,1H246a1,1,0,0,0,1-1v-1.5C247,174.17,242.33,173,240,173Z",
  transform: "translate(-224 -160)",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_24",
  "data-name": "Rectangle 24",
  width: 24,
  height: 24,
  fill: "none"
});

function SvgUsersFocused(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "People",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersFocused);
export default __webpack_public_path__ + "static/media/users_focused.e93741d4.svg";
export { ForwardRef as ReactComponent };